import { useMemo } from 'react';

import InsightsApiExport from 'components/insights/layout/InsightsApiExport';
import { InsightsQueryParams } from 'components/insights/query/useInsightsAnalytics';
import { getBusinessDevelopmentAnalyticsFilters, useBusinessDevelopmentStore } from 'stores/businessDevelopmentStore';

type Props = {
  disabled?: boolean;
  filename?: string;
  show?: boolean;
  params: InsightsQueryParams;
  extraFilters?: Record<string, unknown>;
};

export default function BusinessDevelopmentApiExport({ extraFilters, ...props }: Props) {
  const storeFilters = useBusinessDevelopmentStore((state) => getBusinessDevelopmentAnalyticsFilters(state));

  const analyticsFilters = useMemo(
    () => (storeFilters && extraFilters ? { ...storeFilters, ...extraFilters } : storeFilters),
    [storeFilters, extraFilters]
  );

  return <InsightsApiExport {...props} analyticsFilters={analyticsFilters} />;
}
